import VisitaDermatologica from "./visitadermatologica/index"

export default {
    VisitaDermatologica
}